export var LotteryIconClassEnum;
(function (LotteryIconClassEnum) {
    LotteryIconClassEnum["Money"] = "fa-coins";
    LotteryIconClassEnum["Ticket"] = "fa-check";
    LotteryIconClassEnum["Currency"] = "fa-money-bill-wave";
    LotteryIconClassEnum["Shard"] = "fa-user";
})(LotteryIconClassEnum || (LotteryIconClassEnum = {}));
